import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const addCourseRegistrationApi = async (
    CourseOfferingId: string,
    Duration: number,
    TimeZone: string,
    TimeRange: string,
    UserId: string,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/CourseRegistration/Create`, {
            CourseOfferingId,
            Duration,
            TimeZone,
            TimeRange,
            UserId
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}

export const getCourseRegistrationApi = async (
    url: string,
    page: number,
    itemsPerPage: number,
    selectedStatuses: string[],
    selectedGender: string,
    selectedCourseType: string,
    searchTerm: string
) => {
    const token = cookies.get('authToken');
    const params = new URLSearchParams();

    // Define all statuses
    const allStatuses = [
        "New",
        "Fee Requested",
        "In Progress",
        "Not Interested",
        "On Hold",
        "Ready for batch",
        "Assigned to batch"
    ];

    params.append("pageNumber", page.toString());
    params.append("pageSize", itemsPerPage.toString());
    params.append("selectedGender", selectedGender);
    params.append("selectedCourseType", selectedCourseType);
    params.append("searchTerm", searchTerm);

    // Append statuses: if none selected, use all
    const statusesToSend = selectedStatuses.length > 0 ? selectedStatuses : allStatuses;
    statusesToSend.forEach(status => {
        params.append("selectedStatus", status);
    });

    try {
        const response = await axios.get(
            `${url}/CourseRegistration/GetAll?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const getCourseRegistrationByIdApi = async (id: string, url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/CourseRegistration/GetById/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const getRegistrationByUserId = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/CourseRegistration/GetByUserId`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCourseRegistrationApi = async (
    id: string,
    courseOfferingId: string,
    duration: number,
    timeZone: string,
    timeRange: string,
    status: string,
    fee: number,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.put(
            `${url}/CourseRegistration/Update`, {
            id,
            courseOfferingId,
            duration,
            timeZone,
            timeRange,
            status,
            fee
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error;
    }
};

export const deleteCourseRegistrationApi = async (
    id: string,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/CourseRegistration/Delete`, {
            id,
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error;
    }
};

export const updateCourseRegistrationStatusApi = async (
    id: string,
    status: string,
    url: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.put(
            `${url}/CourseRegistration/UpdateStatus/${id}`,
            status,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',

                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error;
    }
};

export const getFeeRequestApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/CourseRegistration/GetFeeRequest`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};